import React from "react";
import { useGlobalContext } from "../../utils/globalContext";

const EntriesSection = ({ content }) => {
  const { Trans } = useGlobalContext();

  return (
    <div className="entriesSection" style={{ backgroundImage: `url(${content.image?.url})` }}>
      <div className="title">{content.title}</div>
      <div className="content">
        {content.entries.map((entry, i) => (
          <div key={i}>
            <div className="subtitle">
              <Trans>{entry.title}</Trans>
            </div>
            <Trans>
              <div className="paragraphs">{entry.text}</div>
            </Trans>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EntriesSection;
